import React from "react";

export default function Assesment4Summary() {
  return <div>Assessment4Summary</div>;
}
